import { ScrollReveal } from './ScrollReveal';
import { useLang } from '@/lib/translations';

export default function FinalCTA() {
  const { t } = useLang();
  const c = t.finalCta;
  return (
    <section className="relative py-24 sm:py-32 overflow-hidden" data-testid="final-cta-section">
      <div className="absolute inset-0 grid-bg pointer-events-none" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-aurocle-gold/6 rounded-full blur-[200px] pointer-events-none" />

      <div className="relative max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <ScrollReveal>
          <div className="overline mb-6">{c.overline}</div>
          <h2 className="font-heading text-3xl sm:text-5xl tracking-tighter font-medium text-aurocle-text mb-6 leading-tight">
            {c.h2_1}
            <span className="font-accent italic text-aurocle-gold">{c.h2_accent}</span>
          </h2>
          <p className="text-base sm:text-lg text-aurocle-platinum-muted max-w-2xl mx-auto mb-10 leading-relaxed">
            {c.sub}
          </p>
        </ScrollReveal>

        <ScrollReveal delay={100}>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
            <a href="#contact" className="btn-gold cta-burning" data-testid="final-book-meeting-btn">{c.cta1}</a>
            <a href="#contact" className="btn-outline cta-outline-glow" data-testid="final-request-demo-btn">{c.cta2}</a>
          </div>
          <a href="mailto:info@aurocle.world" className="btn-ghost text-xs" data-testid="final-contact-btn">
            {c.cta3}
          </a>
        </ScrollReveal>

        <ScrollReveal delay={200}>
          <p className="text-xs text-aurocle-text-secondary mt-12 max-w-xl mx-auto leading-relaxed">
            For enterprise discussions, private deployments, architecture sessions, or strategic introductions, contact us directly or schedule a private digital meeting.
          </p>
        </ScrollReveal>
      </div>
    </section>
  );
}
